module.exports = __webpack_public_path__ + "static/media/vnpay.01791672.png";